import SAJM_GLOBALS from "../constants";
import GlobalUser from "../models/User";


export class MailController{


    async sendMail(to=null, cc=null, cci=null, subject=null, body=null, attachment=null) {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();


        let _=require("underscore");
        const formData = new FormData();
        
        //add attachements -> create a unique id for each file
        _.each(attachment, function(item){
            formData.append('file_'+String(Math.floor(Math.random() * (10000))),item.data);
        });

        
        

        try {
            const apiFunctionParams =  {
                dlto: [],
                dlcc: [],
                dlcci: [], 
                to: to,
                cc: cc,
                cci: cci,
                subject: subject,
                body: body,
            };

            formData.append('apiFunctionName',"sendNewsletter");
            formData.append('apiFunctionParams',JSON.stringify(apiFunctionParams));
            formData.append('apiKey',apiKey);
            formData.append('apiToken',token);



            const requestOptions = {
                method: 'POST',
                body: formData
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("MailController.sendMail:"+error);
        }

    }


   

}